import React from 'react';
import { EyeIcon, LockIcon } from 'lucide-react';
import type { ToolScreenshot } from '../types/project';
interface ScreenshotCardProps {
  screenshot: ToolScreenshot;
}
export function ScreenshotCard({
  screenshot
}: ScreenshotCardProps) {
  return <figure style={{
    borderRadius: 'var(--b-radius)'
  }} className="flex flex-col overflow-hidden border border-[var(--b-border)] bg-[var(--b-surface)]" data-id="element-173" data-mp="3qd53e0jfe6hh">
      <figcaption className="flex items-center gap-2 border-b border-[var(--b-border)] px-5 py-3" data-id="element-174" data-mp="2xn68hoijvf4w">
        <LockIcon className="h-3.5 w-3.5 shrink-0 text-[var(--b-accent)]" aria-hidden="true" data-id="element-175" data-mp="2solj6k4u6fv8" />
        <span className="text-xs font-semibold text-[var(--b-text)]" data-id="element-176" data-mp="36o4icnfo6gve">{screenshot.label}</span>
      </figcaption>

      <a href={screenshot.url} target="_blank" rel="noreferrer noopener" className="group relative flex flex-1 items-center justify-center bg-[var(--b-surface-alt)] p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--b-accent)]" data-id="element-177" data-mp="32jwpce26ierd">
        <img src={screenshot.url} alt={screenshot.alt} className="max-h-52 w-full rounded object-contain" loading="lazy" data-id="element-178" data-mp="2o5em07dhqwlm" />
        <span className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-0 transition group-hover:opacity-100" data-id="element-179" data-mp="2x7fdenm1mofd">
          <span className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-semibold" style={{
          backgroundColor: 'var(--b-accent)',
          color: 'var(--b-on-accent)'
        }} data-id="element-180" data-mp="32336he3nc1q5">
            <EyeIcon className="h-3 w-3" aria-hidden="true" data-id="element-181" data-mp="2eg4ogbzvolq4" />
            View full size
          </span>
        </span>
      </a>

      {screenshot.note && <p className="border-t border-[var(--b-border)] px-5 py-3 font-mono text-[10px] uppercase tracking-[0.14em] text-[var(--b-dim)]" data-id="element-182" data-mp="2j7wbwdnqmbc1">
          {screenshot.note}
        </p>}
    </figure>;
}